// Mock Data - Will be replaced with backend integration

export const personalInfo = {
  name: 'Segun Adesanya',
  nickname: 'President Raindas',
  title: 'Full-Stack Engineer • Information Security & Software Engineer • Creative Technologist',
  subtitle: 'Founder, Raindas Technologies Limited',
  tagline: 'Building secure financial systems, crafting digital experiences, and empowering the next generation of developers.',
  bio: 'Multidisciplinary engineer and founder with 8+ years building fintech platforms, exploring creative tech through gaming, cinematography, music, and IoT. Passionate about teaching and mentoring aspiring developers. Founded Raindas Technologies to deliver cutting-edge software solutions.',
  email: 'segun@presidentraindas.com',
  phone: '+234 818 925 3129',
  github: 'https://github.com/raindas',
  linkedin: 'https://linkedin.com/in/segun-adesanya',
  twitter: 'https://twitter.com/iamraindas',
  website: 'https://presidentraindas.com',
  companyWebsite: 'https://raindas.co',
  companyName: 'Raindas Technologies Limited',
  location: 'Lagos, Nigeria',
  portraitImage: 'https://res.cloudinary.com/diyjfppkm/image/upload/v1780180612/7adaa80e-05bb-4586-b5b2-54350768d98d_dnu2u2.jpg',
  status: 'Available for new projects',
};

export const skills = {
  technical: [
    'PHP',
    'Laravel',
    'JavaScript',
    'TypeScript',
    'Vue.js',
    'Nuxt.js',
    'Swift',
    'Ionic',
    'FastAPI',
    'Python',
    'MySQL',
    'Redis',
    'Docker',
    'AWS',
    'Git',
    'REST APIs',
    'Linux',
    'Vercel',
    'Paystack',
    'System Architecture',
    'Database Design',
    'PWA Development',
    'Fintech Development'
  ],
  creative: ['Video Editing', 'Music Production', 'Game Design', 'IoT Development'],
  soft: ['Mentorship', 'Public Speaking', 'Technical Writing', 'Team Leadership'],
};

export const projects = {
  fintech: [
    {
      id: 'ft1',
      title: 'Sendalat',
      description:
        'Cross-border payments platform enabling users in Canada and the United States to send money to Nigeria with a seamless mobile-first experience. Includes multi-currency wallets, secure transfers, transparent exchange rates, biometric authentication, and transaction tracking.',
      techStack: [
        'Swift',
        'SwiftUI',
        'Skip.tools',
        'Laravel',
        'Vue.js',
        'TypeScript',
        'PHP',
        'MySQL',
      ],
      category: 'Fintech',
      image: 'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/b8/58/d2/b858d237-3d56-26fc-d74f-173b30003d0c/sendalat_preview_2.png/460x996bb.webp',
      link: 'https://sendalat.com/',
      year: 2025,
    },
    {
      id: 'ft2',
      title: 'SiqoTrader / SiqoApp',
      description:
        'Unified fintech and digital commerce ecosystem supporting crypto trading, gift card exchange, travel bookings, event ticketing, and multi-wallet financial services across mobile and web platforms.',
      techStack: [
        'Swift',
        'SwiftUI',
        'Skip.tools',
        'Nuxt',
        'Vue.js',
        'Laravel',
        'TypeScript',
        'PHP',
        'MySQL',
      ],
      category: 'Fintech / Crypto / Digital Commerce',
      image: 'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/1d/d5/2f/1dd52f12-bf09-40eb-1c44-3087c174ef04/SiqoApp-ios-preview-1.png/460x996bb.webp',
      link: 'https://siqotrader.com/',
      year: 2025,
    },
    {
      id: 'ft3',
      title: 'FirstCentral Mobile',
      description:
        'Mobile credit bureau application providing users access to credit scores, credit reports, identity verification, and credit monitoring services.',
      techStack: [
        'Swift',
        'SwiftUI',
        'REST APIs',
        'Firebase Cloud Messaging',
        'CoreData',
        'Keychain Services',
      ],
      category: 'Credit Bureau / Fintech',
      image: 'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/75/d6/56/75d656e8-3f4f-b2ef-cb63-fc7af00ad3c6/9266b330-c594-4cba-8628-fd8d3b778e6e_Design_3.jpg/460x998bb.webp',
      link: 'https://apps.apple.com/ng/app/firstcentral-mobile/id6477953215',
      year: 2024,
    },
  ],

  enterprise: [
    {
      id: 'en1',
      title: 'LedgerFlow',
      description:
        'Progressive Web App for logistics and operations management with role-based dashboards, centralized reporting, and workflow digitization for executives and managers.',
      techStack: [
        'React',
        'TypeScript',
        'FastAPI',
        'Python',
        'Tailwind CSS',
        'REST API',
        'Vercel',
        'PWA',
      ],
      category: 'Logistics / SaaS',
      image: 'https://lh4.googleusercontent.com/mAef9QaDyzcWuGdUAx_Gf72sDYR9X5mj-REDyJoZmkhPVS7hIzrD_76fbANdi8Dn292htLERFia8cG7Xbct-g1sjlRqzW7HuGppxDEniNEP1TYB4u8LyyjrQBpbCMSAEVJD89_ld88g7V0z0wgMtVk0',
      link: 'https://ledger-flow-nkeu.vercel.app',
      year: 2026,
    },
    {
      id: 'en2',
      title: 'Green Circle Energy (Nig.) Ltd',
      description:
        'Corporate website for a multi-industry energy and technology company showcasing services, expertise, partnerships, and operational capabilities.',
      techStack: [
        'HTML5',
        'CSS3',
        'JavaScript',
        'PHP',
      ],
      category: 'Enterprise / Energy',
      image: 'https://www.greencircleltd.com/assets/images/logo.svg',
      link: 'https://greencircleltd.com',
      year: 2022,
    },
    {
      id: 'en3',
      title: 'CyberCohorts',
      description:
        'Cybersecurity education platform showcasing training programs, mentorship offerings, consultancy services, and enabling student enrollment and lead generation.',
      techStack: [
        'HTML5',
        'CSS3',
        'JavaScript',
        'PHP',
      ],
      category: 'Cybersecurity Education',
      image: 'https://www.cybercohorts.org/images/logo.png',
      link: 'https://www.cybercohorts.org',
      year: 2023,
    },
  ],

  nonprofit: [
    {
      id: 'np1',
      title: 'Islamic Education Trust, Lagos',
      description:
        'Website for a non-profit organization focused on Islamic education, community development, and youth empowerment.',
      techStack: [
        'Nuxt.js',
        'Vue.js',
        'TypeScript',
        'Tailwind CSS',
        'PHP',
        'MySQL',
      ],
      category: 'Non-Profit / Education / Religious Organization',
      image: 'https://islamiceducationtrust.com/logo_light.svg',
      link: 'https://islamiceducationtrust.com',
      year: 2022,
    },
    {
      id: 'np2',
      title: 'Arrhaf Foundation',
      description: 'Website for a Nigerian non-profit supporting genuinely poor but academically promising children through education sponsorship and intervention programs.',
      techStack: [
        'HTML5',
        'CSS3',
        'JavaScript',
        'PHP',
        'MySQL'
      ],
      category: 'Non-Profit / Education / Child Sponsorship / Intervention Programs',
      image: 'https://arrhaffoundation.org/assets/images/logo.png',
      link: 'https://arrhaffoundation.org',
      year: 2026,
    }
  ],

  logistics: [
    {
      id: 'lg1',
      title: 'Luxton Ace Logistics Platform',
      description:
        'Corporate logistics website for freight and logistics services, built to present operations, services, and company information in a structured and professional format.',
      techStack: [
        'Laravel',
        'Blade',
        'PHP',
        'MySQL',
        'HTML5',
        'CSS3',
        'JavaScript',
      ],
      category: 'Logistics',
      image: 'https://luxtonace.com/images/luxtonace-logo.jpg',
      link: 'https://luxtonace.com',
      year: 2024,
    },
  ],

  gaming: [
    {
      id: 'gm1',
      title: '2D Platformer Game',
      description:
        'Developed an indie platformer with custom physics engine, procedural level generation, and original soundtrack.',
      techStack: ['Unity', 'C#', 'Blender', 'Audacity'],
      category: 'Gaming',
      image: 'https://images.unsplash.com/photo-1552820728-8b83bb6b773f',
      year: 2024,
    },
    {
      id: 'gm2',
      title: 'Mobile Puzzle Game',
      description:
        'Casual mobile game with 10,000+ downloads featuring minimalist design and addictive gameplay mechanics.',
      techStack: ['Unity', 'Swift', 'Firebase', 'AdMob'],
      category: 'Gaming',
      image: 'https://images.unsplash.com/photo-1511512578047-dfb367046420',
      year: 2023,
    },
  ],

  cinematography: [
    {
      id: 'cm1',
      title: 'Tech Documentary Series',
      description:
        'Produced and directed a 5-part documentary exploring the African tech ecosystem and innovation hubs.',
      techStack: ['Premiere Pro', 'After Effects', 'DaVinci Resolve'],
      category: 'Cinematography',
      image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4',
      year: 2024,
    },
    {
      id: 'cm2',
      title: 'Short Film: "The Debug"',
      description:
        "A short film about a developer's surreal journey debugging code, blending reality with digital worlds.",
      techStack: ['Cinema Camera', 'Premiere Pro', 'Color Grading'],
      category: 'Cinematography',
      image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728',
      year: 2023,
    },
  ],

  music: [
    {
      id: 'ms1',
      title: 'Electronic Album: "Binary Dreams"',
      description:
        'Self-produced electronic album exploring themes of technology and human connection. 50K+ streams.',
      techStack: ['Ableton Live', 'Serum', 'Mixing/Mastering'],
      category: 'Music',
      image: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d',
      year: 2024,
    },
  ],

  iot: [
    {
      id: 'iot1',
      title: 'Smart Home Automation System',
      description:
        'Custom IoT solution for home automation with voice control, energy monitoring, and mobile app integration.',
      techStack: ['Raspberry Pi', 'Arduino', 'MQTT', 'React Native'],
      category: 'IoT',
      image: 'https://images.unsplash.com/photo-1558002038-1055907df827',
      year: 2024,
    },
  ],

  os: [
    {
      id: 'os1',
      title: 'Custom Linux Distribution',
      description:
        'Lightweight Linux distro optimized for developers with pre-configured development tools and productivity apps.',
      techStack: ['Linux Kernel', 'Bash', 'Package Management'],
      category: 'Operating Systems',
      image: 'https://images.unsplash.com/photo-1629654297299-c8506221ca97',
      year: 2023,
    },
  ],
};

export const awards = [
  {
    id: 'aw1',
    title: 'Best Fintech Innovation Award',
    organization: 'Nigerian Fintech Association',
    year: 2024,
    description: 'Recognized for innovative cross-border payment solution enabling seamless currency conversions.',
    category: 'Industry Recognition',
  },
  {
    id: 'aw2',
    title: 'Hackathon Winner - Payment Systems Track',
    organization: 'Lagos Tech Summit',
    year: 2023,
    description: 'First place for developing a real-time payment reconciliation system in 48 hours.',
    category: 'Competition',
  },
  {
    id: 'aw3',
    title: 'AWS Certified Solutions Architect',
    organization: 'Amazon Web Services',
    year: 2023,
    description: 'Professional certification for designing distributed systems on AWS platform.',
    category: 'Certification',
  },
  {
    id: 'aw4',
    title: 'Outstanding Alumni Award',
    organization: 'University of Lagos',
    year: 2022,
    description: 'Recognized for contributions to tech education and mentoring students.',
    category: 'Academic Honor',
  },
  {
    id: 'aw5',
    title: 'Community Leader of the Year',
    organization: 'Developer Circles Lagos',
    year: 2022,
    description: 'Awarded for organizing 20+ tech workshops and mentoring 100+ junior developers.',
    category: 'Community',
  },
];

export const teaching = [
  {
    id: 'tch1',
    title: 'Lead Instructor - Web Development Bootcamp',
    organization: 'Code Academy Lagos',
    period: '2022 - Present',
    description: 'Teaching full-stack web development to 200+ students. Curriculum covers HTML, CSS, JavaScript, React, and Laravel.',
    students: '200+',
    type: 'Bootcamp',
  },
  {
    id: 'tch2',
    title: 'Volunteer Mentor - Girls Who Code',
    organization: 'Girls Who Code Nigeria',
    period: '2021 - Present',
    description: 'Mentoring young women interested in technology careers. Focus on building confidence and technical skills.',
    students: '50+',
    type: 'Mentorship',
  },
  {
    id: 'tch3',
    title: 'Guest Lecturer - Mobile App Development',
    organization: 'University of Lagos',
    period: '2023 - 2024',
    description: 'Teaching iOS and Android development to computer science students. Practical projects and industry insights.',
    students: '100+',
    type: 'University',
  },
  {
    id: 'tch4',
    title: 'Workshop Facilitator - High School Coding',
    organization: 'Multiple Secondary Schools',
    period: '2020 - Present',
    description: 'Introducing programming fundamentals to high school students through interactive workshops and coding challenges.',
    students: '300+',
    type: 'Workshop',
  },
];

export const leadership = [
  {
    id: 'ld1',
    title: 'Founder & CEO',
    organization: 'Raindas Technologies Limited',
    period: '2020 - Present',
    description: 'Founded and leading a technology company delivering cutting-edge software solutions, mobile applications, and digital transformation services to businesses across Africa.',
    type: 'Professional',
  },
  {
    id: 'ld2',
    title: 'Community Lead',
    organization: 'Developer Circles Lagos',
    period: '2022 - Present',
    description: 'Leading a community of 500+ developers. Organizing meetups, hackathons, and technical workshops.',
    type: 'Community',
  },
  {
    id: 'ld3',
    title: 'Core Maintainer',
    organization: 'Open Source Payment Library',
    period: '2021 - Present',
    description: 'Contributing to and maintaining a popular payment processing library used by 1000+ projects.',
    type: 'Open Source',
  },
  {
    id: 'ld4',
    title: 'President - Computer Science Society',
    organization: 'University of Lagos',
    period: '2016 - 2017',
    description: 'Led the largest tech student organization, organizing tech talks and coding competitions.',
    type: 'University',
  },
  {
    id: 'ld5',
    title: 'Tech Lead',
    organization: 'Fintech Startup',
    period: '2018 - 2020',
    description: 'Led a team of 8 engineers building cross-border payment solutions. Architected scalable systems.',
    type: 'Professional',
  },
];

export const testimonials = [
  {
    id: 'ts1',
    name: 'Amaka Okonkwo',
    role: 'Former Student',
    organization: 'Now Software Engineer at Paystack',
    text: 'Segun\'s mentorship changed my career trajectory. His patient teaching style and real-world examples made complex concepts easy to understand.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956',
  },
  {
    id: 'ts2',
    name: 'Dr. Chinedu Eze',
    role: 'Professor',
    organization: 'University of Lagos',
    text: 'Segun brings invaluable industry experience to the classroom. Students consistently rate his guest lectures as the most impactful.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e',
  },
  {
    id: 'ts3',
    name: 'Fatima Bello',
    role: 'Mentee',
    organization: 'Girls Who Code Participant',
    text: 'I never thought I could be a programmer until I met Segun. His encouragement and guidance helped me land my first tech internship.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80',
  },
];

export const stats = {
  experience: '8+',
  projects: '20+',
  students: '12+',
  communities: '3',
};
